// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3rzOqcc_fz2J0dc5Ac5yg_","toast":"_6Vnf3iweyWraAxY6qSQAj","back":"_3wbV7HGZ9lL-Hc2S77wSS4"};